import styled from 'styled-components';

interface IDivProps {
  open: boolean;
  drawerwidth: number;
}

export const MainContainer = styled.div<IDivProps>`
  transition: none !important;
  flex-grow: 1;
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  transition: margin
    ${(props) => {
      return `${props.theme.transitions.duration.leavingScreen} ${props.theme.transitions.easing.sharp}`;
    }} !important;
  margin-left: ${(props) => (props.open ? '0' : `-${props.drawerwidth}px`)};

  @media ${(props) => props.theme.device.tablet} {
    margin-left: ${(props) => `-${props.drawerwidth}px`} !important;
    padding: 4px;
  }

  ${(props) =>
    props.open &&
    `transition: margin ${props.theme.transitions.duration.enteringScreen} ${props.theme.transitions.easing.easeOut} !important;
    width: calc(100% - ${props.drawerwidth}px) !important;`}
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px;
  justify-content: space-between;
  min-height: 56px;
  @media (min-width: 600px) {
    min-height: 64px;
  }
`;